/* eslint-disable */
export default {
  cancel: 'Cancelar',
  pmiChangeConfirmed: 'Alterar',
  pmiChangeConfirmTitle: 'Pretende alterar as definições da reunião pessoal?',
  pmiChangeConfirmContext:
    'A alteração destas definições irá afetar todas as reuniões que utilizam o seu ID ou nome da reunião pessoal, incluindo as que já agendou',
  updatePassword: 'Atualizar palavra-passe',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"pmiChangeConfirmed"@#@ @source: @#@"Change"@#@
// @key: @#@"pmiChangeConfirmTitle"@#@ @source: @#@"Change Personal Meeting settings?"@#@
// @key: @#@"pmiChangeConfirmContext"@#@ @source: @#@"Changing these settings will affect all meetings that use your personal meeting ID or name, including those you've already scheduled"@#@
// @key: @#@"updatePassword"@#@ @source: @#@"Update password"@#@
